// extracted by mini-css-extract-plugin
export default {"container":"jYF1epEAJxdKtrrEdplf","settings":"mGELLC4yVbCwlKZrdz_O"};